import React from 'react';
import { useSpeechSynthesis } from 'react-speech-kit';
import PropTypes from 'prop-types';

// Icons
import PlayIcon from './Icons/PlayIcon';
import StopIcon from './Icons/StopIcon';

const ReadArticleButton = ({ content }) => {
  const { speak, speaking, supported, cancel } = useSpeechSynthesis();

  return (
    <div>
      {supported && speaking ? (
        <button type="button" className="flex flex-middle" onClick={() => cancel()}>
          <StopIcon />
          <span className="text-uppercase ml-1">STOP LISTENING TO THIS ARTICLE</span>
        </button>
      ) : (
        <button type="button" className="flex flex-middle" onClick={() => speak({ text: content })}>
          <PlayIcon />
          <span className="text-uppercase ml-1">LISTEN TO THIS ARTICLE</span>
        </button>
      )}
    </div>
  );
};

ReadArticleButton.propTypes = {
  content: PropTypes.string.isRequired,
};

export default ReadArticleButton;
